import React from 'react'

const socialLinks = [
  {
    icon: 'fa-youtube-play',
    name: 'Youtube',
    url: 'https://www.youtube.com/channel/UC8CD1QecqtlQU9UWapUYjhw',
  },
  {
    icon: 'fa-twitter',
    name: 'Twitter',
    url: 'https://twitter.com/tampopo_diary',
  },
  // {
  //   icon: 'fa-instagram',
  //   name: 'Instagram',
  //   url: '#',
  // },
]

const Footer: React.FC = () => {
  return (
    <footer>
      <ul className="icons">
        {socialLinks.map((social) => {
          const { icon, name, url } = social
          return (
            <li key={name}>
              <a href={url} className={`icon alt ${icon}`}>
                <span className="label">{name}</span>
              </a>
            </li>
          )
        })}
      </ul>
      <ul className="copyright">
        <li>&copy; たんぽぽ絵日記</li>
        <li>
          Design: <a href="http://html5up.net">HTML5 UP</a>
        </li>
      </ul>
    </footer>
  )
}

export default Footer
